import { useHistory, useParams, useRouteMatch } from 'react-router-dom';
import ZtServiceFactory from '@src/services/zt';
import qs from '@xfe-team/utils/src/query-string-util';
import { useEffect } from 'react';

class BaseStore {
  $history;
  /**
   * store中初始化service接口变量
   */
  $ztService = ZtServiceFactory.getDefaultInstance();

  $props;

  /**
   * 跳转至具体的路由
   * @param {string} url - 跳转路由地址
   * @param {boolean} [isReplace] - 是否替换
   */
  redirect(url, isReplace = false) {
    if (isReplace) {
      this.$history.replace(url);
    } else {
      this.$history.push(url);
    }
  }

  /**
   * 创建 search params 参数
   * @private
   */
  _createSearchParams() {
    let { search = '' } = this.$history.location;
    search = search.replace(/^\?/, '');
    useEffect(
      () => {
        if (search) {
          this.$searchParams = qs.parse(search);
        } else {
          this.$searchParams = {};
        }
      },
      [search]
    );
  }

  /**
   * 获取url参数
   * @param {*} name 参数名
   * @returns
   */
  getParameterByNames(name, url) {
    if (!url) url = window.location.href;
    name = name.replace(/[[]]/g, '$&');
    var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
      results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, ' '));
  }

  use(props) {
    this.$props = props || {};
    this.$history = useHistory();
    /**
     * 路由参数
     * @type {History}
     */
    this.$routeParams = useParams();
    this.$routeMatch = useRouteMatch();
    this._createSearchParams();
  }
}

export default BaseStore;
